// Product page functionality
document.addEventListener('DOMContentLoaded', () => {
  // Initialize button loading
  const customButtons = document.querySelectorAll('.product-form__submit-custom');
  customButtons.forEach((button) => {
    button.addEventListener('click', function(e) {
      this.classList.add('loading');
      setTimeout(() => this.classList.remove('loading'), 3000);
    });
  });
});

// Sticky buy button logic using a clone that triggers the original button
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth <= 767) {
    const originalButton = document.querySelector('.product-form__submit-custom');
    // Find the footer element
    const footer = document.querySelector('footer-group.footer-group');

    if (!originalButton || !footer) {
        console.log('🔍 Sticky button or footer not found. Aborting.');
        return;
    }
    
    let stickyButton = null;
    let isStickyVisible = false;
    
    // Create a sticky clone button (but don't add to DOM yet)
    function createStickyButton() {
      const clone = originalButton.cloneNode(true);
      clone.classList.add('product-form__submit-custom--sticky');
      clone.style.position = 'fixed';
      clone.style.bottom = '10px';
      clone.style.left = '20px';
      clone.style.right = '20px';
      clone.style.width = 'calc(100vw - 40px)';
      clone.style.borderRadius = '30px';
      clone.style.margin = '0';
      clone.style.zIndex = '30';
      clone.style.boxShadow = '0 4px 24px rgba(0,0,0,0.15)';
      clone.style.pointerEvents = 'auto';
      clone.style.display = 'flex';
      clone.style.justifyContent = 'center';
      clone.style.alignItems = 'center';
      
      // Remove any loading state from the clone
      clone.classList.remove('loading');
      
      // When sticky button is clicked, trigger the original button and show loading
      clone.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('🔍 Sticky clone clicked, triggering original button');
        
        // Add loading to both buttons
        clone.classList.add('loading');
        originalButton.classList.add('loading');
        
        setTimeout(() => {
          clone.classList.remove('loading');
          originalButton.classList.remove('loading');
        }, 3000);
        
        originalButton.click();
      });
      
      return clone;
    }
    
    function showStickyButton() {
      if (isStickyVisible) return;
      if (!stickyButton) stickyButton = createStickyButton();
      document.body.appendChild(stickyButton);
      isStickyVisible = true;
    }
    
    function hideStickyButton() {
      if (!isStickyVisible) return;
      if (stickyButton && stickyButton.parentNode) {
        stickyButton.parentNode.removeChild(stickyButton);
      }
      isStickyVisible = false;
    }
    
    function handleScroll() {
      const originalButtonRect = originalButton.getBoundingClientRect();
      const footerRect = footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      
      // Check if original button is visible in viewport
      const isOriginalVisible = originalButtonRect.bottom > 0 && originalButtonRect.top < windowHeight;
      
      // Check if the footer is in view (or close to it)
      // We hide the sticky button when the top of the footer is above the bottom of the screen
      const isFooterVisible = footerRect.top < windowHeight;

      // Show sticky button if the original is NOT visible AND the footer is NOT yet visible.
      if (!isOriginalVisible && !isFooterVisible) {
        showStickyButton();
      } else {
        // Hide sticky button if the original IS visible OR the footer IS visible.
        hideStickyButton();
      }
    }
    
    // Throttle scroll for performance
    let ticking = false;
    function throttledScroll() {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    }
    
    window.addEventListener('scroll', throttledScroll);
    window.addEventListener('resize', throttledScroll);
    handleScroll(); // Initial check
    
  }
});
